module.exports = __webpack_public_path__ + "img/event_active.0fda072a.svg";